module.exports = __webpack_public_path__ + "static/media/cx-phone-icon.3772bf78.svg";